const TEXT = {
    "cat": {
        "navBar": {
            "home": "HOME",
            "aboutUs": "CONEIX-NOS",
            "services": "SERVEIS",
            "activities": "ACTIVITATS",
            "contactUs": "CONTACTE",
            "takeAppointment": "RESERVAR CITA",
            "appointmentBtn": "javascript:abrirCitaOnline('6e416d5e902d5abf368e7168e8d5f3dd-1','cat')",
            "appointmentBtnText": "reservar"
        },
        "home": {
            "subtitle-1": "FISIOTERÀPIA",
            "subtitle-2": "OSTEOPATIA",
            "services": "SERVEIS",
            "activities": "ACTIVITATS",
            "aboutUs": "CONEIX-NOS",
            "contactUs": "CONTACTE",
            "onlyWhatsapp": "només whatsapp",
            "location": "UBICACIÓ",
            "locationText-1": "C/ Major 2,",
            "locationText-2": "La Beguda Alta",
            "locationText-3": "08782",
            "servicesLinks": {
                "Àmbits d'actuació": {
                    "link": "#action-areas-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/ambitosLQ.2c951369.jpg",
                    "imageAlign": "align-bottom"
                },
                "Fisioteràpia": {
                    "link": "#fisio-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/fisioLQ.77fc594d.jpg",
                    "imageAlign": "align-bottom"
                },
                "Osteopatia": {
                    "link": "#osteo-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/aparato-locomotorLQ.3ac78eab.jpg",
                    "imageAlign": ""
                },
                "INDIBA": {
                    "link": "#indiba-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/indiba1LQ.dc6ec720.jpg",
                    "imageAlign": ""
                },
                "Consultes de Salut Integrativa (PNIE)": {
                    "link": "#pnie-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/pnie.jpg",
                    "imageAlign": ""
                }
            },
            "activitiesLinks": {
                "Exercici funcional": {
                    "link": "#functional-exercise-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/ejFunctLink.jpg",
                    "imageAlign": "align-top"
                },
                // "Ioga": {
                //     "link": "#yoga-container",
                //     "text": "Més informació",
                //     "image": "https://epanareda.github.io/ossis/img/hathaLQ.01af4e46.jpg",
                //     "imageAlign": "align-top-hata"
                // },
                // "Música en família": {
                //     "link": "#music-with-family-container",
                //     "text": "Més informació",
                //     "image": "https://epanareda.github.io/ossis/img/musicaFamLQ.0085d396.jpg",
                //     "imageAlign": ""
                // }
            },
            "aboutUsLinks": {
                "Equip": {
                    "link": "#team-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/equipLQ.9789ab85.jpg",
                    "imageAlign": "align-top-team"
                },
                "El centre": {
                    "link": "#center-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/centro1LQ.dbccefd0.jpg",
                    "imageAlign": ""
                }
            }
        },
        "aboutUs": {
            "title": "CONEIX-NOS",
            "team": "Equip",
            "mainLinks": {
                "Eva Fructuoso Díaz": {
                    "link": "#action-areas-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/eva-profileLQ.23fa3790.jpg"
                },
                "El centro": {
                    "link": "#fisio-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/centro2LQ.19d8fb92.jpg"
                }
            },
            "workers": {
                "1": {
                    "name": "Eva Fructuoso Díaz",
                    "image": "https://epanareda.github.io/ossis/img/eva-profileLQ.23fa3790.jpg",
                    "description":  [
                        "Després de finalitzar els meus estudis de fisioteràpia el 2015 he continuat la meva formació acadèmica enfocada en el coneixement del cos humà.",
                        "M'apassiona la meva feina i poder ajudar la gent. En acabar la carrera vaig estar treballant a domicili, amb la llitera a coll per tot arreu, al cap de poc vaig tenir la gran sort d'entrar en un centre de neuropediatria on vaig aprendre nous valors de la vida, tractava infants amb paràlisi cerebral, síndrome de Rett, síndrome d'Angelman, etc. Sentia la necessitat d'aprendre molt més sobre les patologies del cos humà i com tractar-les, així que, l'any 2017 vaig decidir estudiar un màster en osteopatia que vaig acabar el 2022.",
                        "Transcorreguts 5 anys al centre de neurologia, vaig entrar a treballar en un centre privat de fisioteràpia, on a més de nadons i nens, tractava adults amb diverses dolències.",
                        "Després de 3 anys més de sumar experiències he decidit obrir la meva pròpia consulta.",
                        "Seguiré formant-me sempre, per poder seguir ajudant totes aquelles persones que em podeu necessitar."
                    ]
                },
                "2": {
                    "name": "Alejandro Milán San Miguel",
                    "image": "https://epanareda.github.io/ossis/img/alejandro-profileLQ.40e9cb4b.jpg",
                    "description":  [
                        "Acabo de finalitzar els meus estudis de fisioteràpia i sempre he estat un apassionat de l'esport. He practicat diversos esports com el tennis, el futbol i l'entrenament de força, la qual cosa m'ha permès comprendre de primera mà les necessitats i desafiaments dels esportistes.",
                        "La meva afició en l'esport i el benestar físic em va portar a interessar-me en fisioteràpia esportiva durant la meva formació acadèmica. Al llarg dels meus estudis, he adquirit coneixements en el tractament de lesions esportives, la rehabilitació física i l'optimització del rendiment esportiu.",
                        "A més, he completat una formació en biomecànica de la marxa i he obtingut la titulació en punció seca,  això em permet abordar de manera més efectiva les disfuncions musculoesquelètiques i ajudar els pacients a millorar la seva mobilitat i reduir el dolor. També, recentment m'he format en INDIBA.",
                        "Estic entusiasmat per començar la meva carrera professional en Ossis, on podré aplicar els meus coneixements i experiència per a ajudar als nostres pacients en la recuperació de les seves lesions, millorar el seu rendiment esportiu i aconseguir els seus objectius de salut.",
                        "El meu objectiu és continuar aprenent i creixent com a fisioterapeuta, participant en cursos i formacions professionals que em permetin estar al dia amb les últimes tècniques i avanços en fisioteràpia. Estic compromès a brindar un servei d'alta qualitat i atenció personalitzada a cadascun dels meus pacients."
                    ]
                },
                "3": {
                    "name": "Danae Olmo Barceló",
                    "image": "https://epanareda.github.io/ossis/img/danaeLQ.e1081f23.jpg",
                    "description":  [
                        "Des de ben petita m'he dedicat a l'esport, més en concret al bàsquet, i degut a una lesió que vaig tindre, de la qual vaig necessitar rehabilitació, vaig tindre clar que jo volia ser fisioterapeuta.",
                        "Així que em vaig llençar a per totes i al 2011 vaig acabar la carrera de fisioteràpia. Tinc més de 10 anys d'experiència en el sector de la rehabilitació, fisioteràpia esportiva i traumatologia.",
                        "Per mi, la fisioteràpia no és una feina, és vocació, i m'agrada molt treballar per a millorar la qualitat de vida dels meus pacients.",
                        "Entremig, m'he anat formant amb cursos com el kinesiotaping, els ganxos, la teràpia cupping (més coneguda com teràpia amb ventoses), i d'hipopressius, a més d'haver treballat amb aparatologia com la radiofreqüència, ones de xoc i d'altres. Finalment, vaig completar els meus estudis amb el màster d'Osteopatia al 2017 i així tindre un concepte més global del cos humà.",
                        "Actualment, treballo en el camp de la geriatria, i ara tinc la oportunitat de treballar també en Ossis i formar-me amb ells com a professional per a poder donar el millor servei als pacients.",
                        "El meu objectiu, és estar actualitzada i poder aprendre sempre una mica més d'aquesta gran professió."
                    ]
                },
                "4": {
                    "name": "Marta Cabello",
                    "image": "https://epanareda.github.io/ossis/img/mCabelloLQ.468b687c.jpg",
                    "description":  [
                        "Sóc Marta Cabello, des de ben jove he estat vinculada al món de l'esport de manera professional. Després de finalitzar els estudis de Fisioteràpia el 2005, vaig especialitzar-me amb un postgrau en fisioteràpia esportiva (2008).",
                        "Tot i així, no va ser fins al naixement del meu primer fill que vaig adonar-me de la manca d'informació sobre la recuperació de la dona després del part o una cesària. Aquest descobriment em va portar a formar-me en aquesta àrea i, el 2021, vaig finalitzar el màster en fisioteràpia del sòl pelvià, una especialitat que m'apassiona.",
                        "Durant la meva trajectòria, he treballat en diferents instal·lacions esportives, amb equips de futbol sala, motociclisme i centres de fisioteràpia, i durant 13 anys vaig dirigir el meu propi centre de fisioteràpia i pilates.",
                        "El 2024 vaig començar a especialitzar-me en fisioteràpia oncològica, una branca amb un gran potencial per ajudar moltes persones en el seu procés de recuperació.",
                        "Com a professional, m'agrada estar en constant formació per oferir un servei de qualitat i poder ajudar al màxim de persones possible."
                    ]
                },
                "5": {
                    "name": "Enrique Cordovez",
                    "image": "https://epanareda.github.io/ossis/img/enriqueLQ.ccbcc27e.jpg",
                    "description":  [
                        "L'any 2024 em vaig graduar com a fisioterapeuta a Canàries i vaig decidir iniciar un camí d'aprenentatge continu sobre el cos humà. Aquell mateix any vaig començar el Màster en Osteopatia i, el 2025, em vaig traslladar a Barcelona per continuar formant-me i poder oferir un abordatge més complet i individualitzat a cada pacient.",
                        "L'esport sempre ha format part de la meva vida, fet que m'ha permès entendre de prop les demandes físiques dels esportistes. Actualment col·laboro amb l'equip de futbol de Sant Esteve Sesrovires, treballant en la prevenció i tractament de lesions per optimitzar el rendiment i la recuperació.",
                        "A més, compto amb formació en punció seca i electropunció, tècniques que m'ajuden a tractar de manera més precisa les disfuncions musculoesquelètiques.",
                        "Avui tinc la sort d'unir-me a la família Ossis, on puc continuar creixent com a fisioterapeuta i futur osteòpata, aprendre d'un gran equip i aportar tota la meva energia i dedicació a cada pacient."
                    ]
                },
                // "6": {
                //     "name": "Judith Cano",
                //     "image": "https://epanareda.github.io/ossis/img/judithLQ.6e81c665.jpg",
                //     "description":  [
                //         "Sóc la Judith Cano instructora i professora de Hatha Ioga i Yin Ioga. Fa més de 15 anys que practico yoga i farà cosa d'un any que vaig sentir la necessitat de profunditzar i viure des de una altra perspectiva aquest món tant beneficiós que és el ioga.",
                //         "Les meves primeres aportacions a l'hora de compartir els meus coneixements del ioga amb altres persones ha sigut en les meves formacions com a Técnica Prevenció de Riscos Professionals, la meva altra professió, ja que pot ajudar a gestionar situacions d'estrès aportant mecanismes per fer front de manera adequada altes exigències emocionals reduint els riscos psicosocials que es poden originar en el món laboral i donant indicacions que poden ajudar a millorar desequilibris posturals.",
                //         "En aquests moments tinc una gran motivació personal de compartir de manera més amplia aquests coneixements impartint classes com les proposades a OSSIS.",
                //         "Des del punt de vista personal el ioga m'ha aportat grans beneficis tant físics com emocionals equilibrant aquesta prioritat que és la connexió de cos-ment millorant la salut en general i integrant la seva filosofia en el dia a dia.",
                //         "Físics perquè aporta força física i millora la flexibilitat convertint-se en un gran pilar pel desenvolupament d'altres activitats com per exemple la dansa i emocional perquè es composa de tècniques que ajudant a reduir l'estrès i donar força mental.",
                //         "El ioga és un gran camí i un aprenentatge molt llarg pel que el meu objectiu és seguir formant-me en nivells avançats i completant amb especialitzacions com el ioga aeri.",
                //         "A més he complementat els meus coneixements amb formacions en cadenes miofascials i hipopressius.",
                //         "Estic immensament feliç de poder compartir el ioga amb altres persones ajudant a millorar la seva salut sent gran defensora de les classes reduïdes ja que aporten una atenció més personalitzada, una millora de la tècnica, proporcionant un ambient més íntim i relaxat, un progrés més ràpid, una adaptació a necessitats especials i proporcionant una major connexió alumne-instructora."
                //     ]
                // },
                "6": {
                    "name": "Sara González",
                    "image": "https://epanareda.github.io/ossis/img/saraGonzalez.jpg",
                    "description":  [
                        "Sóc graduada en Infermeria des del 2016 i, durant més de set anys, he treballat en l'àmbit hospitalari. Aquella etapa em va ensenyar el valor de la cura, la importància d'escoltar i, sobretot, que moltes persones conviuen amb símptomes que es repeteixen, tornen o no acaben de millorar mai, cronificant-se… perquè només es tapen, però no s'arriba a comprendre què està passant realment a dins del cos.",
                        "Amb aquesta inquietud, vaig decidir formar-me en PsicoNeuroImmunoEndocrinologia (PNIE). Actualment em dedico exclusivament a acompanyar persones que volen cuidar-se i sanar des d'un enfocament més complet, profund i respectuós.",
                        "Per a mi, la salut integrativa és mirar la salut sense pedaços: entendre com es relacionen les teves hormones, la teva digestió, la teva energia, les teves emocions, el descans i la teva manera de viure. És buscar l'origen del problema, no solucions provisionals per a tota la vida.",
                        "A consulta treballo principalment amb hàbits saludables, alimentació conscient, regulació de l'estrès, moviment, descans i suplementació natural només quan realment aporta valor. El meu enfocament és proper, tranquil i pràctic: vull que entenguis la teva salut i que puguis prendre decisions que et facin sentir millor avui i a llarg termini.",
                        "Si vens a veure'm, t'acompanyo des de l'escolta i amb el compromís d'ajudar-te a descobrir què necessita el teu cos per tornar a funcionar en equilibri."
                    ]
                },
                // "7": {
                //     "name": "Marta Sogas",
                //     "image": "https://epanareda.github.io/ossis/img/sogasLQ.8dcdbf38.jpg",
                //     "description":  [
                //         "Em dic Marta i acompanyo a les persones a través de la música. Soc musicòloga i pedagoga musical i sempre he estat relacionada amb el món de la música.",
                //         "Treballo gràcies a tot allò que he après, que he viscut i que he experimentat de manera constant al llarg de la meva trajectòria musical. He pogut observar i vivenciar els beneficis de la música a través de la sensibilització i el moviment, alguns dels quals són la coordinació, la memòria, la comunicació i la concentració, com també la millora de les habilitats motores i rítmiques.",
                //         "Amb cançons, audicions, ritmes, danses, jocs de falda i instruments compartirem una estona plena de música. Acompanyaré a les famílies a establir una connexió entre l'adult i l'infant a través de la música, oferint recursos i experimentant els beneficis que ens pot oferir la música."
                //     ]
                // }
            },
            "center": {
                "title": "El centre",
                "description": [
                    "Ossis es un centre privat de fisioteràpia i osteopatia situat a La Beguda Alta i fundat el 2023.",
                    "En aquest centre ens importa molt la qualitat de vida de les persones, oferim un tractament individualitzat a cada pacient basat principalment en la teràpia manual amb tècniques i exercicis personalitzats."
                ],
                "images": {
                    "1": "https://epanareda.github.io/ossis/img/centro1LQ.dbccefd0.jpg",
                    "2": "https://epanareda.github.io/ossis/img/centro2LQ.19d8fb92.jpg"
                }
            }
        },
        "services": {
            "title": "SERVEIS",
            "mainLinks": {
                "Àmbits d'actuació": {
                    "link": "#action-areas-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/ambitosLQ.2c951369.jpg",
                    "imageAlign": "align-bottom"
                },
                "Fisioteràpia": {
                    "link": "#fisio-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/fisioLQ.77fc594d.jpg",
                    "imageAlign": "align-bottom"
                },
                "Osteopatia": {
                    "link": "#osteo-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/aparato-locomotorLQ.3ac78eab.jpg",
                    "imageAlign": ""
                },
                "INDIBA": {
                    "link": "#indiba-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/indiba1LQ.dc6ec720.jpg",
                    "imageAlign": ""
                },
                "Consultes de Salut Integrativa (PNIE)": {
                    "link": "#pnie-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/pnie.jpg",
                    "imageAlign": ""
                }
            },
            "areasOfActionInfo": {
                "title": "Àmbits d'actuació",
                "description": "",
                "methodsOfTreatement": {
                    "Articulació temporomandibular (ATM)": [
                        "L'aparell masticatori pot considerar-se com un element independent, manté relacions neurològiques a través del nucli del trigemin i mecàniques per les fàscies cervicals i facials amb sistemes neuromusculars del coll, així que la pèrdua de to de la musculatura cervical o lateral del coll pot alterar el procés masticatori i manifestar-se el dolor orofacial."
                    ],
                    "Pediatria": [
                        "La fisioteràpia pediàtrica és aquell tractament de qualsevol afectació a la infància, tant aguda com crònica, que pertorba el desenvolupament motriu, i per tant, limita el potencial per a la independència en la vida adulta, arribant a interferir en la qualitat de vida tant a curt com a llarg termini.",
                        "En el cas de nadons és molt important realitzar una sessió de fisioteràpia i osteopatia ja que, durant el part, el seu cap ha estat sotmès a diferents pressions i és recomanable una valoració de les sutures cranials. Aquestes sutures, poden estar pertorbant altres sistemes i donar, per exemple, problemes de còlics o restrenyiment o problemes de la son…",
                        "A qui podem ajudar?"
                    ],
                    "Fisioteràpia del Sòl Pelvià": [
                        "La fisioteràpia del sòl pelvià és una especialitat dedicada a l'avaluació, tractament i prevenció de disfuncions relacionades amb els músculs i estructures que conformen el sòl pelvià. Aquest conjunt de músculs sosté òrgans com la bufeta, l'úter (en dones) i el recte, i és clau per a funcions com la continència urinària i fecal, l'estabilitat lumbar i pèlvica, i la salut sexual.",
                        "[U]Quan cal acudir a fisioteràpia del sòl pelvià?",
                        "Aquesta teràpia està indicada tant per a dones com per a homes que presentin símptomes com:",
                        "[U]En què consisteix el tractament?",
                        "Després d'una valoració individualitzada, el fisioterapeuta pot emprar diverses tècniques com:",
                        "[U]Beneficis de la fisioteràpia del sòl pelvià",
                        "El tractament ajuda a millorar la qualitat de vida, l'autonomia i el benestar físic i emocional. A més, és una alternativa eficaç i no invasiva per a moltes disfuncions pèlviques que afecten el dia a dia."
                    ],
                    "Geriatria": [
                        "És important mantenir les funcions físiques i mentals el millor possible per a tenir la màxima independència, es per això que es realitzen tècniques de manteniment, amb exercicis personalitzats segons requereixi cada pacient."
                    ],
                    "Neurologia": [
                        "Aquest tractament té com objectiu millorar les capacitats físiques del pacient, adaptant els exercicis en els moviments que fa en la seva vida quotidiana. Depenent de l'afectació del sistema nerviós, es realitza una personalització del tractament."
                    ],
                    "Traumatologia": [
                        "És una especialitat per a lesions del sistema musculesquelètic, ossi i lligamentós com ara els esquinços, tendinopaties, sobrecàrregues musculars, condropaties, fractures, etc. Amb l'objectiu de reduir el dolor i la inflamació per tal d'anar recuperant la mobilitat."
                    ],
                    "Esportiu": [
                        "És molt important la prevenció de lesions en l'àmbit esportiu, així com la recuperació i readaptació a l'esport després d'una lesió. Es realitzen exercicis i tractaments individualitzats a cada pacient tenint en compte l'estat físic, la postura i el tipus d'esport."
                    ]
                }
            },
            "fisioInfo": {
                "title": "Fisioteràpia",
                "description": "« Prové de la unió de les lletres gregues de “Physis” que significa naturalesa i “Therapehia” que significa tractament. Segons l'OMS “és la ciència que aplica tractaments a través de mitjans físics mitjançant exercici terapèutic, massoteràpia i electroteràpia »",
                "methodsOfTreatement": {
                    "Tractament de punts gallet": [
                        "Existeixen diferents tècniques per al tractament dels punts gallet, sempre ens adaptem al pacient, alguns exemples de tractament són els estiraments, crioteràpia, punció seca, digito-pressió, massoteràpia, tècniques de múscul energia o “levées de tensions”, exercici controlat…"
                    ],
                    "Estiraments": [
                        "Per tal de relaxar la musculatura i augmentar la circulació sanguínia en músculs i articulacions realitzem estiraments. Des del centre OSSIS us ensenyarem quin és el millor moment per estirar, què cal estirar, de quina manera i en quina freqüència."
                    ],
                    "Electroteràpia": [
                        "El TENS (estimulació elèctrica nerviosa transcutània) proporciona bons resultats en casos de dolor agut i crònic de molts tipus. Els impulsos elèctrics col·locats en la zona dolorida o a prop d'ella, estimulen els nervis per a bloquejar els senyals de dolor al cervell i, així, el dolor no és percebut. Amb el TENS a baixa freqüència s'alliberen endorfines, la substància per alleugerir el dolor propi del cos.",
                        "NMES (estimulació elèctrica neuromuscular) s'utilitza com a complement de l'entrenament esportiu a tots els nivells. Els impulsos elèctrics estimulen els nervis per a enviar senyals a un múscul específic que reacciona contraient-se de la mateixa forma que l'activitat muscular normal."
                    ],
                    "Embenats": [
                        "Depenent del tipus de lesió realitzarem un embenat o un altre, per exemple, quan es tracta de lesions com els esquinços i és necessari immobilitzar l'articulació, utilitzarem un embenat adhesiu.",
                        "També podem utilitzar el Kinesiotape, aquest tipus d'embenat és molt elàstic i s'adapta a l'estructura. Té moltes funcions, depenent de la manera d'aplicar-lo pot ajudar a la relaxació muscular, o pel contrari a l'estimulació d'un múscul en concret."
                    ],
                    "Auriculoacupuntura": [
                        "Aquestes tècniques s'utilitzen complementàriament a la fisioteràpia i a la osteopatia.",
                        "L'auriculoteràpia forma part de la medicina alternativa, consisteix en estimular determinats punts de l'orella mitjançant agulles o llavors ja que les diferents parts del cos es veuen reflectides a l'orella. Aquesta tècnica es pot utilitzar pel tractament d'una dolència o per ajudar en problemes d'insomni, estrès, etc."
                    ],
                    "Reflexologia podal": [
                        "És una altra tècnica que utilitzem a més del tractament de fisioteràpia. Mitjançant la reflexologia podal podem activar la circulació sanguínia de tot el cos, ajuda a alliberar tensions i potser una tècnica complementària al tractament d'un dolor muscular o inclús en problemes de restrenyiment, estrès, etc."
                    ],
                    "Drenatge limfàtic": [
                        "És una tècnica de massoteràpia molt suau que s'aplica als ganglis i vasos del sistema limfàtic per estimular la circulació i reabsorció del líquid limfàtic. S'utilitza per a reduir edemes o la retenció de líquid. Funciona molt bé en patologies que produeixen inflamació, edema o limfedemes en alguna extremitat."
                    ],
                    "Invasives": [
                        "La punció seca és l'aplicació percutània d'un estímul (agulla) per aconseguir com a resposta una contracció involuntària i reflexa.",
                        "Com a tècnica complementària a la punció seca es realitza electroneuroacupuntura aplicant elèctrodes a les agulles."
                    ]
                }
            },
            "osteoInfo": {
                "title": "Osteopatía",
                "description": "« Combinació de la paraula grega “Osteo” que vol dir os i “Pathy” que significa sentir. L'osteopatia proposa un concepte holístic de visió global del cos amb 3 sistemes completament connectats. »",
                "methodsOfTreatement": {
                    "Cranial": [
                        "A nivell cranial existeixen canvis de conformació tensional. L'osteopatia tracta de portar a l'equilibri els ossos cranials així com tots els teixits del seu voltant ( fàscies, músculs…) mitjançant tècniques molt suaus fins i tot relaxants.",
                        "La teràpia cranial por ajudar a reduir dolors o tensions estructurals encara que també s'utilitza per a problemes d'ATM, bruxisme, estrès, etc. Les tècniques cranials poden ajudar a reduir mals de cap i/o migranyes."
                    ],
                    "Visceral": [
                        "No només existeixen els dolors musculars, quan hi ha alguna alteració visceral també pot donar dolor referit a una altre part del cos com, per exemple, un dolor a l'espatlla dreta pot venir per una afectació del fetge.",
                        "Es comú pensar que tenim una hèrnia discal que pinça el nervi i que per això es pot tenir ciàtica amb irradiació al membre inferior, però quan es tracta de l'esquena, podria passar el mateix, i pot haver-hi una alteració en una víscera i repercutir en una altre zona. Un altre exemple seria el cas de l'estómac, que pot donar un dolor referit a la zona de l'estèrnum o manifestar-se a la zona de los trapezis.  És per això que és molt important realitzar un bon diagnòstic i aplicar les tècniques adaptades a cada pacient."
                    ],
                    "Aparell locomotor": [
                        "Les alteracions de l'aparell locomotor poden presentar-se com un dolor o restricció de moviment en ossos, articulacions, lligaments, músculs, tendons i nervis. Amb l'osteopatia es realitzen una combinació de tècniques per disminuir el dolor i restablir les funciona d'aquests sistemes."
                    ]
                }
            },
            "indibaInfo": {
                "title": "INDIBA",
                "description": "",
                "methodsOfTreatement": {
                    "": [
                        "La tecnologia INDIBA utilitza el poder de la reparació natural del cos, proporcionant diversos beneficis terapèutics als pacients. El mètode de tractament es basa en la freqüència 448 kHz, que produeix resultats clínics consistents i ha estat demostrada científicament.",
                        "La teràpia de radiofreqüència introdueix una ona electromagnètica indolora que desencadena un efecte de bioestimulació en el cos. Aquesta bioestimulació accelera la curació i ajuda a la recuperació en qualsevol zona de tractament."
                    ],
                    "Alleujament del dolor i la inflamació en lesions musculoesquelètiques": [
                        "Tendinopatia aquílea, Lesió de turmell, dolor artrític i artrósico, patologia cervical, discopatia lumbar, tendinopatia, lesió neural, distensió muscular, síndrome piramidal, dolor articular, síndrome de dolor miofascial, hematomes i ferides."
                    ],
                    "Després de procediments quirúrgics en intervencions musculoesquelètiques": [
                        "Eritema postquirúrgic, inflamació postquirúrgica, dolor i lesió cutània postquirúrgica, úlceres per pressió."
                    ],
                    "Rehabilitació funcional física": [
                        "ROM (rang de moviment)."
                    ],
                    "Esportistes": [
                        "Quan un esportista es lesiona, intenta qualsevol cosa per a accelerar el procés natural de reparació dels teixits. La teràpia de radiofreqüència INDIBA estimula la reparació tissular, que pot combinar-se amb la teràpia manual i altres tècniques per a obtenir millors resultats.",
                        "Els tractaments INDIBA(R) poden començar en la fase aguda d'una lesió perquè la modulació contínua de la freqüència garanteix un efecte de bioestimulació sense induir calor en el teixit.",
                        "Es pot augmentar el flux sanguini profund en un 79%, amb un increment significatiu de la temperatura del teixit, que es manté molt més allà del temps que dura el tractament."
                    ]
                }
            },
            "pnieInfo": {
                "title": "Consultes de Salud Integrativa (PNIE)",
                "description": "",
                "methodsOfTreatement": {
                    "": [
                        "La PNIE (PsicoNeuroImmunoEndocrinologia) és una disciplina científica que estudia la connexió entre tots els sistemes del cos: sistema immunitari, endocrí, nerviós, digestiu, les emocions i, molt especialment, els hàbits de vida.",
                        "Si pateixes alguna patologia o experimentes símptomes persistents i encara no has trobat solucions efectives, les consultes de salut integrativa et poden ajudar a comprendre què està passant al teu organisme i a actuar des de l'arrel.",
                        "Les consultes es basen en els coneixements de Sara González, infermera especialitzada en PNIE, i tenen un enfocament completament personalitzat. S'aprofundeix en la teva història de vida per identificar patrons que puguin estar influint en el teu estat de salut i trobar l'origen del malestar.",
                        "L'abordatge es realitza des de diferents àmbits, sent la implementació d'hàbits saludables la base del procés, sempre adaptada a cada cas.",
                        "Cada consulta és individual i dissenyada específicament per a tu."
                    ],
                    "Quines patologies es poden abordar?": [
                        ""
                    ],
                    "Tipus de consulta": [
                        "[U]Primera consulta",
                        "Espai dedicat a recollir la teva història clínica i personal, analitzar els símptomes i revisar proves o informes mèdics si els aportes. A partir d'aquí s'elabora una proposta terapèutica individualitzada per a les setmanes següents.",
                        "[U]Consultes de seguiment",
                        "Revisió de l'evolució del cas, ajust del pla terapèutic i acompanyament proper durant el procés de canvi. La freqüència s'adapta a cada persona.",
                    ],
                }
            },
            "lists": {
                "Pediatria2": [
                    "Bebès amb patiment fetal perinatal",
                    "Craneosinostosi, deformitats cranials i problemes de la son",
                    "Otitis, obstrucció del canal llagrimall",
                    "Espasticitat, rigidesa, hipotonia o distonies",
                    "Miopaties",
                    "Fre de la llengua",
                    "Sdes i malformacions genètiques",
                    "Deformitats de la columna vertebral, escoliosis, cifosis...",
                    "PCI",
                    "Còlics del lactant, gasos, estrenyiment, disquècia, reflux",
                    "Problemes d'atenció i desenvolupament motriu"
                ],
                "Fisioteràpia del Sòl Pelvià2": [
                    "Incontinència urinària o fecal",
                    "Prolapses (descens d'òrgans pelvians)",
                    "Dolor pèlvic crònic",
                    "Disfuncions sexuals (dolor en les relacions, disfunció erèctil, etc.)",
                    "Recuperació postpart o després d'una cirurgia pèlvica",
                    "Preparació per al part"
                ],
                "Fisioteràpia del Sòl Pelvià4": [
                    "Exercicis de reforç (com els exercicis de Kegel)",
                    "Teràpia manual i miofascial",
                    "Biofeedback i electroestimulació",
                    "Educació postural i entrenament funcional"
                ],
                "Invasives0": [
                    "Redueix la concentració de substàncies d'estímuls dolorosos, disminuint el dolor local i referit",
                    "Relaxa la musculatura",
                    "Revascularitza",
                    "Restaura patrons normals de moviment"
                ],
                "Quines patologies es poden abordar?0": [
                    "Salut digestiva",
                    "Còlon irritable, gastritis, reflux, intoleràncies, disbiosi (SIBO, paràsits)",
                    "Desajustos hormonals",
                    "SOP, endometriosi, menopausa, hipo/hipertiroïdisme, dismenorrea, amenorrea",
                    "Metabolisme",
                    "Diabetis tipus 1 i 2, resistència a la insulina, colesterol elevat, hipertensió, sobrepès",
                    "Estat d'ànim",
                    "Estrès, ansietat, insomni, fatiga crònica, depressió",
                    "Inflamació i dolor",
                    "Fibromiàlgia, artritis, artrosi, problemes articulars",
                    "Autoimmunitat",
                    "Crohn, colitis, al·lèrgies, psoriasi, Hashimoto, entre d'altres",
                    "Desintoxicació i salut hepàtica",
                    "Reducció de tòxics, metalls pesants i equilibri de la microbiota"
                ]
            },
            "pictures": {
                "Pediatria": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/pediatria1LQ.b7a5b13b.jpg",
                        "topPosition": "0"
                    },
                    {
                        "picture": "https://epanareda.github.io/ossis/img/pediatria2LQ.8fd545e6.jpg",
                        "topPosition": "-40%"
                    },
                    {
                        "picture": "https://epanareda.github.io/ossis/img/pediatria3LQ.7ff272ac.jpg",
                        "topPosition": "-30%"
                    },
                    {
                        "picture": "https://epanareda.github.io/ossis/img/pediatria4LQ.2ed8c757.jpg",
                        "topPosition": "-40%"
                    }
                ],
                "Fisioteràpia del Sòl Pelvià": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/solPelvicLQ.jpg",
                        "topPosition": "-15%"
                    }
                ],
                "Geriatria": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/geriatria1LQ.0e32ab70.jpg",
                        "topPosition": "0"
                    }
                ],
                "Esportiu": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/deportivo1LQ.095b86a6.jpg",
                        "topPosition": "-15%"
                    }
                ],
                "Embenats": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/vendajesLQ.53e699c8.jpg",
                        "topPosition": "-25%"
                    }
                ],
                "Auriculoacupuntura": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/auriculoterapiaLQ.1c54f58d.jpg",
                        "topPosition": "0"
                    }
                ],
                "Reflexologia podal": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/reflex-podal1LQ.3e2ef91c.jpg",
                        "topPosition": "-20%"
                    }
                ],
                "Invasives": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/invasivas1LQ.05562916.jpg",
                        "topPosition": "0"
                    }
                ],
                "Cranial": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/craneal1LQ.f7e95d74.jpg",
                        "topPosition": "0"
                    }
                ],
                "Visceral": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/visceral1LQ.1ae340be.jpg",
                        "topPosition": "-25%"
                    }
                ],
                "Aparell locomotor": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/aparato-locomotorLQ.3ac78eab.jpg",
                        "topPosition": "-30%"
                    }
                ],
                "Esportistes": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/indiba2LQ.c616254e.jpg",
                        "topPosition": "-25%"
                    },
                    {
                        "picture": "https://epanareda.github.io/ossis/img/indiba3LQ.db6f94e9.jpg",
                        "topPosition": "0"
                    }
                ],
                "Quines patologies es poden abordar?": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/pnie.jpg",
                        "topPosition": "-35%"
                    },
                ]
            }
        },
        "activities": {
            "title": "ACTIVITATS",
            "mainLinks": {
                "Exercici Funcional": {
                    "link": "#functional-exercise-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/ejFunctLink.jpg",
                    "imageAlign": "align-top"
                },
                // "Ioga": {
                //     "link": "#yoga-container",
                //     "text": "Más información",
                //     "image": "https://epanareda.github.io/ossis/img/hathaLQ.01af4e46.jpg",
                //     "imageAlign": "align-top-hata"
                // },
                // "Música en Família": {
                //     "link": "#music-with-family-container",
                //     "text": "Más información",
                //     "image": "https://epanareda.github.io/ossis/img/musicaFamLQ.0085d396.jpg",
                //     "imageAlign": ""
                // }
            },
            "functionalExerciceInfo": {
                "title": "Exercici Funcional",
                "description": "",
                "methodsOfTreatement": {
                    "Classes d'Exercici Funcional en Ossis": [
                        "En Ossis, sabem l'important que és moure's de manera efectiva per a portar una vida activa i saludable. Per això, oferim classes d'exercici funcional, dissenyades per a millorar la teva força, resistència, mobilitat i coordinació, sempre adaptades a les teves necessitats."
                    ],
                    "Què és l'exercici funcional?": [
                        "L'exercici funcional es basa en moviments que simulen les activitats de la vida diària. Aquest enfocament no sols millora el teu rendiment físic, sinó que també enforteix el teu cos de manera integral, ajudant-te a prevenir lesions i a fer les teves tasques quotidianes amb major facilitat i seguretat."
                    ],
                    "Com són les nostres classes?": [
                        "En cada sessió, utilitzem eines com a gomes, kettlebells i manuelles, combinades amb exercicis personalitzats segons el teu nivell físic. Els nostres fisioterapeutes especialitzats t'acompanyaran en tot moment, assegurant-se que realitzis cada moviment correctament i de manera segura."
                    ],
                    "Beneficis de les nostres classes": [
                        "Aquests son els principals beneficis de realitzar exercici funcional:"
                    ],
                    "Horaris flexibles": [
                        "Sabem que el teu temps és valuós, per això oferim horaris molt flexibles, tant en torns de demà com de tarda, perquè puguis triar el moment que millor s'adapti a la teva rutina.",
                        "Veuen a provar una classe i descobreix com l'exercici funcional pot transformar la teva vida!",
                        "Contacta'ns per a més informació o per a reservar la teva plaça."
                    ]
                }
            },
            // "yogaInfo": {
            //     "title": "Ioga",
            //     "description": "",
            //     "methodsOfTreatement": {
            //         "Yin Ioga": [
            //             "És una fusió entre Hatha Yoga i la Mefdicina China. És una pràctica introspectiva i meditativa que fomenta un estat de calma i consciència plena que s'enfoca en treballar els teixits més profunds com son els lligaments, tendons i fascia mitjançant postures mantingudes durnt un temps prollongat que permet un estirament profund i una major apertura de les articulacions.",
            //             "Amb la práctica de Yin activem el nostreSNP induïnt a la calma i la relaxació contrarestant l'estat constant d'acció i alerta de la nostra vida diaria mitjançant la práctica d'asanas Yin i el seu moviment d'energia, pero també amb la respiracióla la meditació i el Mindfulness.",
            //             "Amb la respiració podem controlar el nostre SNA que és el pont entre la ment i el cos."
            //         ],
            //         "Hatha Ioga": [
            //             "Forma tradicional de Yoga que combina la pràctica de postures i respiració així com tècniques de respiració que es centra en l'equilibri físic, mental i espiritual amb l'objectiu de reduir estrès i ansietat, millorar la força i la flexibilitat física, fomenta una conexión profunda entre cos i ment.",
            //             "La clau de l'ensenyança i de la seva metodologia és la respiració focalitzant el seu control sobre el cos físic i el seu prana i un camí al autoconeixement."
            //         ],
            //         "Hipopressius": [
            //             "Exercicis posturals i respiratoris on es treballa tota la musculatura respiratòria associats a un ritme respiratori controlat i metodologia d'entrenament que es caracteritza en la disminució de la pressió intra-abdominal.",
            //             "Els seus beneficis son entre d'altres son la tonificació de la musculatura abdomino perineal, millora postural, prevenir l'aparició d'hèrnies, prevenir o reeducar síntomas de incontinència urinaria, liberación miofascial, etc."
            //         ]
            //     }
            // },
            // "musicWithFamilyInfo": {
            //     "title": "Música en Família",
            //     "description": "",
            //     "methodsOfTreatement": {
            //         "Música en Família": [
            //             "Aquesta proposta està adreçada a les famílies (adult i infant de 0 a 3 anys) i es basa en l'estimulació dels infants a través de la música i el joc. Així, a més de passar una bona estona gaudint de la música, el joc, cantar i ballar, es treballa la psicomotricitat, el llenguatge, la coordinació, l'adquisició i el reforç d'hàbits, de rutines, la comunicació, l'expressió… compartint així una estona única de connexió entre l'adult i l'infant."
            //         ]
            //     }
            // },
            "lists": {
                "Beneficis de les nostres classes0": [
                    "Augment de la força i resistència muscular.",
                    "Millora de la postura i estabilitat.",
                    "Reducció del risc de lesions.",
                    "Complement ideal per a la recuperació funcional després de lesions o cirurgies.",
                    "Adaptació personalitzada als teus objectius i capacitats."
                ]
            },
            "pictures": {
                "Beneficis de les nostres classes": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/ejercicioFuncionalLQ.663e6b3b.jpg",
                        "topPosition": "-5px"
                    }
                ],
                // "Yin Ioga": [
                //     {
                //         "picture": "https://epanareda.github.io/ossis/img/yinLQ.c7f5ea24.jpg",
                //         "topPosition": "-40px"
                //     }
                // ],
                // "Hatha Ioga": [
                //     {
                //         "picture": "https://epanareda.github.io/ossis/img/hathaLQ.01af4e46.jpg",
                //         "topPosition": "-40px"
                //     }
                // ],
                "Hipopressius": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/hipopresivosLQ.182a0da3.jpg",
                        "topPosition": "-15px"
                    }
                ],
                // "Música en Família": [
                //     {
                //         "picture": "https://epanareda.github.io/ossis/img/musicaFamLQ.0085d396.jpg",
                //         "topPosition": "0px"
                //     }
                // ]
            }
        },
        "contactUs": {
            "title": "CONTACTE",
            "onlyWhatsapp": "només whatsapp",
            "address": "C/ Major 2, La Beguda Alta (08782)"
        }
    },
    "es": {
        "navBar": {
            "home": "HOME",
            "aboutUs": "CONÓCENOS",
            "services": "SERVICIOS",
            "activities": "ACTIVIDADES",
            "contactUs": "CONTACTO",
            "takeAppointment": "RESERVAR CITA",
            "appointmentBtn": "javascript:abrirCitaOnline('6e416d5e902d5abf368e7168e8d5f3dd-1','es')",
            "appointmentBtnText": "reservar"
        },
        "home": {
            "subtitle-1": "FISIOTERAPIA",
            "subtitle-2": "OSTEOPATÍA",
            "services": "SERVICIOS",
            "activities": "ACTIVIDADES",
            "aboutUs": "CONÓCENOS",
            "contactUs": "CONTACTO",
            "onlyWhatsapp": "solo whatsapp",
            "location": "UBICACIÓN",
            "locationText-1": "C/ Major 2,",
            "locationText-2": "La Beguda Alta",
            "locationText-3": "08782",
            "servicesLinks": {
                "Ámbitos de actuación": {
                    "link": "#action-areas-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/ambitosLQ.2c951369.jpg",
                    "imageAlign": "align-bottom"
                },
                "Fisioterapia": {
                    "link": "#fisio-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/fisioLQ.77fc594d.jpg",
                    "imageAlign": "align-bottom"
                },
                "Osteopatía": {
                    "link": "#osteo-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/aparato-locomotorLQ.3ac78eab.jpg",
                    "imageAlign": ""
                },
                "INDIBA": {
                    "link": "#indiba-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/indiba1LQ.dc6ec720.jpg",
                    "imageAlign": ""
                },
                "Consultas de Salud Integrativa (PNIE)": {
                    "link": "#pnie-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/pnie.jpg",
                    "imageAlign": ""
                }
            },
            "activitiesLinks": {
                "Ejercicio funcional": {
                    "link": "#functional-exercise-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/ejFunctLink.jpg",
                    "imageAlign": "align-top"
                },
                // "Yoga": {
                //     "link": "#yoga-container",
                //     "text": "Més informació",
                //     "image": "https://epanareda.github.io/ossis/img/hathaLQ.01af4e46.jpg",
                //     "imageAlign": "align-top-hata"
                // },
                // "Música en familia": {
                //     "link": "#music-with-family-container",
                //     "text": "Més informació",
                //     "image": "https://epanareda.github.io/ossis/img/musicaFamLQ.0085d396.jpg",
                //     "imageAlign": ""
                // }
            },
            "aboutUsLinks": {
                "Equipo": {
                    "link": "#team-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/teamLQ.f6cdbe8d.jpg",
                    "imageAlign": "align-top"
                },
                "El centro": {
                    "link": "#center-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/centro1LQ.dbccefd0.jpg",
                    "imageAlign": ""
                }
            }
        },
        "aboutUs": {
            "title": "CONÓCENOS",
            "team": "Equipo",
            "mainLinks": {
                "Equipo": {
                    "link": "#action-areas-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/teamLQ.f6cdbe8d.jpg"
                },
                "El centro": {
                    "link": "#fisio-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/centro2LQ.19d8fb92.jpg"
                }
            },
            "workers": {
                "1": {
                    "name": "Eva Fructuoso Díaz",
                    "image": "https://epanareda.github.io/ossis/img/eva-profileLQ.23fa3790.jpg",
                    "description":  [
                        "Finalicé mis estudios de fisioterapeuta en 2015 desde entonces siempre he seguido formándome y queriendo conocer más sobre el cuerpo humano.",
                        "Me apasiona mi trabajo y poder ayudar a la gente. Al salir de la carrera estuve trabajando a domicilio, con la camilla a cuestas para todos los lados, al poco tiempo tuve la gran suerte de entrar en un centro de neuropediatría donde aprendí nuevos valores en la vida, sentía que necesitaba aprender mucho más, así que decidí estudiar osteopatía, después de 5 años, finalicé el master en 2022.",
                        "A nivel laboral, tras 5 años en el centro de neurología, entré a trabajar en un centro de fisioterapia, donde además de bebés y niños, trataba adultos con diversas patologías.",
                        "Después de 3 años más de sumar experiencias he decidido abrir mi propia consulta.",
                        "Seguiré formándome siempre, para poder seguir ayudando a todas aquellas personas que me queráis conocer."
                    ]
                },
                "2": {
                    "name": "Alejandro Milán San Miguel",
                    "image": "https://epanareda.github.io/ossis/img/alejandro-profileLQ.40e9cb4b.jpg",
                    "description":  [
                        "Acabo de finalizar mis estudios de fisioterapia y siempre he sido un apasionado del deporte. He practicado diversos deportes como el tenis, el fútbol y el entrenamiento de fuerza, lo que me ha permitido comprender de primera mano las necesidades y desafíos de los deportistas.",
                        "Mi afición en el deporte y el bienestar físico me llevó a interesarme en fisioterapia deportiva durante mi formación académica. A lo largo de mis estudios, he adquirido conocimientos en el tratamiento de lesiones deportivas, la rehabilitación física y la optimización del rendimiento deportivo.",
                        "Además, he completado una formación en biomecánica de la marcha y he obtenido la titulación en punción seca, lo que me permite abordar de manera más efectiva las disfunciones musculoesqueléticas y ayudar a los pacientes a mejorar su movilidad y reducir el dolor. También, recientemente me he formado en INDIBA.",
                        "Estoy entusiasmado por comenzar mi carrera profesional en Ossis, donde podré aplicar mis conocimientos y experiencia para ayudar a nuestros pacientes en la recuperación de sus lesiones, mejorar su rendimiento deportivo y alcanzar sus objetivos de salud.",
                        "Mi objetivo es continuar aprendiendo y creciendo como fisioterapeuta, participando en cursos y formaciones profesionales que me permitan estar al día con las últimas técnicas y avances en fisioterapia. Estoy comprometido a brindar un servicio de alta calidad y atención personalizada a cada uno de mis pacientes."
                    ]
                },
                "3": {
                    "name": "Danae Olmo Barceló",
                    "image": "https://epanareda.github.io/ossis/img/danaeLQ.e1081f23.jpg",
                    "description":  [
                        "Desde pequeña me he dedicado al deporte, más en concreto al baloncesto, y debido a una lesión que tuve, de la cuál necesité rehabilitación, supe que quería ser fisioterapeuta.",
                        "Así que me lancé a por todas, y en 2011 terminé la carrera de fisioterapia. Tengo más de 10 años de experiencia en el sector de la rehabilitación, fisioterapia deportiva y traumatológica.",
                        "Para mi la fisioterapia no es un trabajo, es una vocación y me gusta mucho trabajar para mejorar la calidad de vida de mis pacientes.",
                        "Entre medio me he formado en cursos como el kinesiotaping, los ganchos, la terapia cupping (más conocida como terapia con ventosas) y de hipopresivos, además de haber trabajado con aparatología como la radiofrecuencia, ondas de choque entre otros. Finalmente, completé mis estudios con el máster de Osteopatía en 2017, y así tener un concepto más global del cuerpo humano.",
                        "Actualmente trabajo en el campo de la geriatría, y ahora tengo la oportunidad de trabajar también en Ossis, y formarme con ellos como profesional para poder dar el mejor servicio a los pacientes.",
                        "Mi objetivo es estar actualizada y poder ir aprendiendo siempre un poco más de esta gran profesión."
                    ]
                },
                "4": {
                    "name": "Marta Cabello",
                    "image": "https://epanareda.github.io/ossis/img/mCabelloLQ.468b687c.jpg",
                    "description":  [
                        "Soy Marta Cabello, desde muy joven he estado vinculada al mundo del deporte de manera profesional. Tras finalizar mis estudios de Fisioterapia en 2005, me especialicé con un posgrado en fisioterapia deportiva (2008).",
                        "Aun así, no fue hasta el nacimiento de mi primer hijo cuando me di cuenta de la falta de información sobre la recuperación de la mujer después del parto o una cesárea. Este descubrimiento me llevó a formarme en esta área y, en 2021, finalicé el máster en fisioterapia del suelo pélvico, una especialidad que me apasiona.",
                        "Durante mi trayectoria, he trabajado en diferentes instalaciones deportivas, con equipos de fútbol sala, motociclismo y centros de fisioterapia, y durante 13 años dirigí mi propio centro de fisioterapia y pilates.",
                        "En 2024 empecé a especializarme en fisioterapia oncológica, un área con un gran potencial para ayudar a muchas personas en su proceso de recuperación.",
                        "Como profesional, me gusta estar en constante formación para ofrecer un servicio de calidad y poder ayudar al mayor número de personas posible."
                    ]
                },
                "5": {
                    "name": "Enrique Cordovez",
                    "image": "https://epanareda.github.io/ossis/img/enriqueLQ.ccbcc27e.jpg",
                    "description":  [
                        "En 2024 me gradué como fisioterapeuta en Canarias y decidí iniciar un camino de aprendizaje continuo sobre el cuerpo humano. Ese mismo año comencé el Máster en Osteopatía y en 2025 me trasladé a Barcelona para seguir formándome y poder ofrecer un abordaje más completo e individualizado a cada paciente.",
                        "El deporte siempre ha sido parte de mi vida, lo que me ha permitido entender de cerca las demandas físicas de los deportistas. Actualmente colaboro con el equipo de fútbol de Sant Esteve Sesrovires, trabajando en la prevención y tratamiento de lesiones para optimizar el rendimiento y la recuperación.",
                        "Además, cuento con formación en punción seca y electropunción, técnicas que me ayudan a tratar de forma más precisa las disfunciones musculoesqueléticas.",
                        "Hoy tengo la suerte de unirme a la familia Ossis, donde puedo seguir creciendo como fisioterapeuta y futuro osteópata, aprender de un gran equipo y aportar toda mi energía y dedicación a cada paciente."
                    ]
                },
                // "6": {
                //     "name": "Judith Cano",
                //     "image": "https://epanareda.github.io/ossis/img/judithLQ.6e81c665.jpg",
                //     "description":  [
                //         "Soy Judith Cano instructora y profesora de Hatha yoga y Yin Yoga. Hace más de 15 años que practico yoga y hace un año que sentí la necesidad de profundizar y vivir desde otra perspectiva de este mundo tan beneficioso que es el Yoga.",
                //         "Mis primeras aportaciones a la hora de compartir mis conocimientos del yoga con otras personas han sido en mis formaciones como Técnica en Prevención de Riesgos Profesionales, mi otra profesión, ya que puede ayudar a gestionar situaciones de estrés, aportando mecanismos para afrontar de manera adecuada altas exigencias emocionales reducido los riesgos psicosociales que pueden originarse en el mundo laboral y dando indicaciones que pueden ayudar a mejorar los desequilibrios posturales.",
                //         "En estos momentos tengo una gran motivación personal de compartir más ampliamente estos conocimientos impartiendo clases completas como las propuestas en OSSIS.",
                //         "Desde el punto de vista personal el Yoga me ha aportado grandes beneficios tanto físicos como emocionales equilibrando esa prioridad que es la conexión de cuerpo-mente mejorando la salud en general e integrando su filosofía en el día a día.",
                //         "Físicos ya que aporta fuerza física y mejora la flexibilidad convirtiéndose en un gran pilar para el desarrollo de otras actividades como por ejemplo la danza y emocional porque se compone de técnicas que ayudan a aliviar el estrés y a dar fuerza mental.",
                //         "El Yoga es un camino y un aprendizaje muy largo por lo que mi objetivo es seguir formándome en niveles más avanzados y completando con especializaciones como yoga aéreo.",
                //         "Además he complementado mis conocimientos con formación en cadenas miofasciales y hipopresivos.",
                //         "Estoy inmensamente feliz de poder compartir el yoga con otras personas ayudando a mejorar su salud siendo gran defensora de las clases reducidas ya que aportan una atención más personalizada, una mejora de la técnica, proporcionando un ambiente más íntimo y relajado, un progreso más rápido, una adaptación a necesidades especiales y proporcionando mayor conexión alumno-instructora."
                //     ]
                // },
                "6": {
                    "name": "Sara González",
                    "image": "https://epanareda.github.io/ossis/img/saraGonzalez.jpg",
                    "description":  [
                        "Soy graduada en Enfermería desde 2016 y, durante más de siete años, trabajé en el ámbito hospitalario. Ese periodo me enseñó el valor del cuidado, la importancia de escuchar y, sobre todo, que muchas personas conviven con síntomas que se repiten, vuelven o nunca terminan de mejorar, cronificándose… porque solo se tapan, pero no se comprende qué está ocurriendo realmente dentro del cuerpo.",
                        "Con esa inquietud, decidí formarme en Psico-Neuro-Inmuno-Endocrinología (PNIE). Actualmente me dedico de forma exclusiva a acompañar a personas que quieren cuidarse y sanar desde un enfoque más completo, profundo y respetuoso.",
                        "Para mí, la salud integrativa es mirar la salud sin parches: entender cómo se relacionan tus hormonas, tu digestión, tu energía, tus emociones, tu descanso y tu forma de vivir. Es buscar el origen del problema, no soluciones provisionales para toda la vida.",
                        "En consulta trabajo principalmente con hábitos saludables, alimentación consciente, regulación del estrés, movimiento, descanso y suplementación natural solo cuando realmente aporta valor. Mi enfoque es cercano, tranquilo y práctico: quiero que entiendas tu salud y que puedas tomar decisiones que te hagan sentir mejor hoy y a largo plazo.",
                        "Si vienes a verme, te acompaño desde la escucha y con el compromiso de ayudarte a descubrir qué necesita tu cuerpo para volver a funcionar en equilibrio."
                    ]
                },
                // "7": {
                //     "name": "Marta Sogas",
                //     "image": "https://epanareda.github.io/ossis/img/sogasLQ.8dcdbf38.jpg",
                //     "description":  [
                //         "Me llamo Marta y acompaño a las personas a través de la música. Soy musicóloga y pedagoga musical y siempre he estado relacionada con el mundo de la música.",
                //         "Trabajo gracias a todo aquello que he aprendido, que he vivido y que he experimentado de manera constante a lo largo de mi trayectoria musical. He podido observar y vivenciar los beneficios de la música a través de la sensibilización y el movimiento, algunos de ellos son la coordinación, la memoria, la comunicación y la concentración, como también la mejora de las habilidades motoras y rítmicas.",
                //         "Con canciones, audiciones, ritmos, bailes, juegos de falda e instrumentos compartiremos un rato lleno de música. Acompañaré a las familias a establecer una conexión entre el adulto/a y el niño/a a través de la música, ofreciendo recursos y experimentando los beneficios que nos puede ofrecer la música."
                //     ]
                // }
            },
            "center": {
                "title": "El centro",
                "description": [
                    "Ossis es un centro privado de fisioterapia y osteopatía situado en La Beguda Alta fundado en 2023.",
                    "En este centro nos importa mucho la calidad de vida de las personas, por lo que se ofrece un trabajo individualizado con el paciente basado principalmente en la terapia manual con técnicas y ejercicios personalizados."
                ],
                "images": {
                    "1": "https://epanareda.github.io/ossis/img/centro1LQ.dbccefd0.jpg",
                    "2": "https://epanareda.github.io/ossis/img/centro2LQ.19d8fb92.jpg"
                }
            }
        },
        "services": {
            "title": "SERVICIOS",
            "mainLinks": {
                "Ámbitos de actuación": {
                    "link": "#action-areas-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/ambitosLQ.2c951369.jpg",
                    "imageAlign": "align-bottom"
                },
                "Fisioterapia": {
                    "link": "#fisio-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/fisioLQ.77fc594d.jpg",
                    "imageAlign": "align-bottom"
                },
                "Osteopatía": {
                    "link": "#osteo-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/aparato-locomotorLQ.3ac78eab.jpg",
                    "imageAlign": ""
                },
                "INDIBA": {
                    "link": "#indiba-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/indiba1LQ.dc6ec720.jpg",
                    "imageAlign": ""
                },
                "Consultas de Salud Integrativa (PNIE)": {
                    "link": "#pnie-container",
                    "text": "Més informació",
                    "image": "https://epanareda.github.io/ossis/img/pnie.jpg",
                    "imageAlign": ""
                }
            },
            "areasOfActionInfo": {
                "title": "Ámbitos de actuación",
                "description": "",
                "methodsOfTreatement": {
                    "Articulación temporo mandibular (ATM)": [
                        "El aparato masticatorio puede considerarse como un elemento independiente, mantiene relaciones neurológicas a través del núcleo del trigémino y mecánicas por medio de las fascias cérvico faciales con sistemas neuromusculares del cuello, así que la pérdida de tono de la musculatura cervical o lateral del cuello puede alterar el proceso masticatorio y manifestarse el dolor orofacial."
                    ],
                    "Pediatría": [
                        "La Fisioterapia pediátrica es aquel tratamiento de cualquier afectación en la infancia, tanto aguda como crónica, que perturba el desarrollo motriz y, por tanto, limita el potencial para la independencia en la vida adulta llegando a interferir en la calidad de vida tanto a corto como largo plazo.",
                        "En el caso de recién nacidos es muy importante realizar una sesión de fisioterapia y osteopatía ya que durante el parto su cabeza se ha sometido a diferentes presiones por lo que se recomienda una valoración de suturas craneales. Estas suturas, pueden estar perturbando otros sistemas y dar por ejemplo problemas de cólicos o estreñimiento o problemas en el sueño…",
                        "A quién podemos ayudar?"
                    ],
                    "Fisioterapia del Suelo Pélvico": [
                        "La fisioterapia del suelo pélvico es una especialidad dedicada a la evaluación, tratamiento y prevención de disfunciones relacionadas con los músculos y estructuras que conforman el suelo pélvico. Este conjunto de músculos sostiene órganos como la vejiga, el útero (en mujeres) y el recto, y es clave para funciones como la continencia urinaria y fecal, la estabilidad lumbar y pélvica, y la salud sexual.",
                        "[U]¿Cuándo acudir a fisioterapia del suelo pélvico?",
                        "Esta terapia está indicada tanto para mujeres como para hombres que presenten síntomas como:",
                        "[U]¿En qué consiste el tratamiento?",
                        "Tras una valoración individualizada, el fisioterapeuta puede emplear distintas técnicas como:",
                        "[U]Beneficios de la fisioterapia del suelo pélvico",
                        "El tratamiento ayuda a mejorar la calidad de vida, la autonomía y el bienestar físico y emocional. Además, es una alternativa eficaz y no invasiva para muchas disfunciones pélvicas que afectan al día a día."
                    ],
                    "Geriatría": [
                        "Es importante mantener las funciones físicas y mentales lo mejor posible para tener la máxima independencia, es por ello que se realizan técnicas para el mantenimiento así como ejercicios personalizados según requiera cada paciente."
                    ],
                    "Neurología": [
                        "Este tratamiento tiene como objetivo mejorar las capacidades físicas del paciente, trabajamos adaptando los ejercicios en los movimientos que lleva a cabo en su vida cotidiana. Dependiendo de la afectación del sistema nervioso, se personaliza el tratamiento a cada persona."
                    ],
                    "Traumatología": [
                        "Es una especialidad para lesiones del sistema musculoesquelético, óseo y ligamentoso como esguinces, tendinopatías, sobrecargas musculares, condropatías, fracturas….Con el objetivo de reducir el dolor y la inflamación e ir recuperando la movilidad."
                    ],
                    "Deportivo": [
                        "Es muy importante la prevención de lesiones en el ámbito deportivo, así como la recuperación y readaptación al deporte después de una lesión. Se realizan ejercicios y tratamientos individualizados a cada paciente teniendo en cuenta el estado físico, la postura y el tipo de deporte."
                    ]
                }
            },
            "fisioInfo": {
                "title": "Fisioterapia",
                "description": "« Proviene de la unión de las voces griegas “Physis” que significa naturaleza y “Therapehia” que significa tratamiento. Según la OMS es “la ciencia que aplica tratamientos a través de medios físicos mediante ejercicios terapéuticos, masoterapia y electroterapia”. »",
                "methodsOfTreatement": {
                    "Tratamiento de puntos gatillo": [
                        "Existen diferentes técnicas para el tratamiento de los puntos gatillo, siempre nos adaptamos al paciente ya que existen diferentes maneras de abordar los puntos gatillo. Estiramientos,crioterapia, punción seca, digito presión, masoterapia, técnicas de músculo energía, ejercicio controlado…"
                    ],
                    "Estiramientos": [
                        "Con el fin de relajar la musculatura y aumentar la circulación sanguínea en músculos y articulaciones realizamos estiramientos. Desde el centro OSSIS os enseñaremos cuál es el mejor momento para estirar, que se debe estirar, de qué manera y en qué frecuencia."
                    ],
                    "Electroterapia": [
                        "El TENS (estimulación eléctrica nerviosa transcutánea) proporciona buenos resultados en casos de dolor agudo y crónico de muchos tipos. Los impulsos eléctricos colocados en la zona dolorida o cerca de ella, estimulan los nervios para bloquear las señales de dolor al cerebro y, así, el dolor no es percibido. Con el TENS a baja frecuencia se liberan endorfinas, la substancia de alivio del dolor propia del cuerpo.",
                        "NMES ( estimulación eléctrica neuromuscular) se utiliza como complemento del entrenamiento deportivo a todos los niveles. Los impulsos eléctricos estimulan los nervios para enviar señales a un músculo específico que reacciona contrayéndose de la misma forma que la actividad muscular normal."
                    ],
                    "Vendajes": [
                        "Dependiendo del tipo de lesión realizaremos un vendaje u otro, existen varios vendajes, por ejemplo cuando se trata de lesiones del tipo esguince y es necesario inmovilizar la articulación utilizaremos una venda adhesiva.",
                        "También podemos utilizar el Kinesiotape, este tipo de vendaje es muy elástico y se adapta a la estructura. Tiene muchas funciones, dependiendo de la manera de aplicarlo puede ayudar a la relajación muscular, o por el contrario a la estimulación de un músculo en concreto."
                    ],
                    "Auriculoterapia": [
                        "Estas técnicas se utilizan como complementarias a la fisioterapia y a la osteopatía.",
                        "La auriculoterapia forma parte de la medicina alternativa,consiste en estimular determinados puntos en la oreja mediante agujas o semillas las distintas partes del cuerpo se ven reflejadas en la oreja, así que se puede utilizar para el tratamiento de una dolencia o para ayudar en problemas de insomnio, estrés."
                    ],
                    "Reflexologia podal": [
                        "Es otra técnica que utilizamos además del tratamiento de fisioterapia, mediante la reflexología podal podemos activar la circulación sanguínea de todo el cuerpo , ayuda a liberar tensiones y puede ser una técnica complementaria al tratamiento de un dolor muscular o incluso en estreñimiento o estrés."
                    ],
                    "Drenaje linfático": [
                        "Es una técnica de masoterapia muy suave que se aplica en los ganglios y vasos del sistema linfático  para estimular la circulación y reabsorción del líquido. Se utiliza para reducir edemas o la retención de líquido. Funciona muy bien en patologías que producen hinchazón, edema o linfedemas en alguna extremidad."
                    ],
                    "Invasivas": [
                        "Punción Seca, aplicación percutánea de un estímulo (aguja) para conseguir como respuesta una contracción involuntaria y refleja.",
                        "Como técnica complementaria a la punción seca se realiza electroacupuntura aplicando electrodos a las agujas."
                    ]
                }
            },
            "osteoInfo": {
                "title": "Osteopatía",
                "description": "« Combinación de la palabra griega osteo o “hueso” y de palabra griega \"pathy\" que significa sentir. La osteopatía propone un concepto holístico de visión global del cuerpo, con sistemas completamente conectados. »",
                "methodsOfTreatement": {
                    "Craneal": [
                        "A nivel craneal existen cambios de conformación tensionales. La osteopatía trata de llevar al equilibrio los huesos craneales así como todos los tejidos de su alrededor(fascias, músculos…) mediante técnicas muy suaves e incluso relajantes.",
                        "La terapia craneal puede ayudar a reducir dolores o tensiones estructurales aunque también se utilizan estas técnicas para problemas en ATM, bruxismo y estrés… Las técnicas craneales pueden ayudar a reducir dolores de cabeza y/o migrañas."
                    ],
                    "Visceral": [
                        "No sólo existen los dolores musculares, cuando existen alteraciones viscerales también pueden dar dolor referido en otras partes del cuerpo, como por ejemplo un dolor de hombro derecho puede venir por afectación del hígado.",
                        "Es común  pensar, que tenemos una hernia discal y que pinza el nervio y por ello tenemos una ciática con irradiación al miembro inferior, pero cuando se trata de la espalda, puede ocurrir lo mismo, puede haber alteración en una víscera y repercutir en otra zona, otro ejemplo sería en el caso del estómago que puede dar dolor referido hacia la zona de esternón, la zona epigástrica e incluso a la zona interescapular, 3era costilla o manifestarse en la zona de los trapecios. Por ello es importante realizar un buen diagnóstico diferencial y aplicar las técnicas adaptadas a cada paciente."
                    ],
                    "Aparato locomotor": [
                        "Las alteraciones en el aparato locomotor pueden llevar a presentar dolor o restricción de movimiento en huesos, articulaciones, ligamentos,músculos, tendones y nervios. Con la osteopatía se realizan una combinación de técnicas para ayudar a disminuir ese dolor y restablecer las funciones de estos sistemas."
                    ]
                }
            },
            "indibaInfo": {
                "title": "INDIBA",
                "description": "",
                "methodsOfTreatement": {
                    "": [
                        "La tecnología INDIBA utiliza el poder de la reparación natural del cuerpo, proporcionando varios beneficios terapéuticos a los pacientes. El método de tratamiento se basa en la frecuencia 448 kHz, que produce resultados clínicos consistentes y ha sido demostrada científicamente.",
                        "La terapia de radiofrecuencia introduce una onda electromagnética indolora que desencadena un efecto de bioestimulación en el cuerpo. Esta bioestimulación acelera la curación y ayuda a la recuperación en cualquier zona de tratamiento."
                    ],
                    "Alivio del dolor y la inflamación en lesiones musculoesqueléticas": [
                        "Tendinopatía aquílea, lesión de tobillo, dolor artrítico y artrósico, patología cervical, discopatía lumbar, tendinopatía, lesión neural, distensión muscular, síndrome piramidal, dolor articular, síndrome de dolor miofascial, hematomas y heridas."
                    ],
                    "Después de procedimientos quirúrgicos en intervenciones musculoesqueléticas": [
                        "Eritema posquirúrgico, inflamación posquirúrgica, dolor y lesión cutánea posquirúrgica, úlceras por presión."
                    ],
                    "Rehabilitación funcional física": [
                        "ROM (rango de movimiento)."
                    ],
                    "Deportistas": [
                        "Cuando un deportista se lesiona, intenta cualquier cosa para acelerar el proceso natural de reparación de los tejidos. La terapia de radiofrecuencia INDIBA estimula la reparación tisular, que puede combinarse con la terapia manual y otras técnicas para obtener mejores resultados.",
                        "Los tratamientos INDIBA(R) pueden comenzar en la fase aguda de una lesión puesto que la modulación continua de la frecuencia garantiza un efecto de bioestimulación sin inducir calor en el tejido.",
                        "Se puede aumentar el flujo sanguíneo profundo en un 79%, con un incremento significativo de la temperatura del tejido, que se mantiene mucho más allá del tiempo que dura el tratamiento"
                    ]
                }
            },
            "pnieInfo": {
                "title": "Consultas de Salud Integrativa (PNIE)",
                "description": "",
                "methodsOfTreatement": {
                    "": [
                        "La PNIE (PsicoNeuroInmunoEndocrinología) es una disciplina científica que estudia la conexión entre todos los sistemas del cuerpo: sistema inmune, endocrino, nervioso, digestivo, emociones y, muy especialmente, los hábitos de vida.",
                        "Si padeces alguna patología o experimentas síntomas persistentes y todavía no has encontrado soluciones efectivas, las consultas de salud integrativa pueden ayudarte a comprender qué está ocurriendo en tu organismo y actuar desde la raíz.",
                        "Las consultas se basan en los conocimientos de Sara González, enfermera especializada en PNIE, y tienen un enfoque completamente personalizado. Se profundiza en tu historia de vida para identificar patrones que puedan estar influyendo en tu estado de salud y encontrar el origen del malestar.",
                        "El abordaje se realiza desde distintos terrenos, siendo la implementación de hábitos saludables la base del proceso, siempre adaptada a cada caso.",
                        "Cada consulta es individual y diseñada específicamente para ti."
                    ],
                    "¿Qué patologías se pueden abordar?": [
                        ""
                    ],
                    "Tipos de consulta": [
                        "[U]Primera consulta",
                        "Espacio dedicado a recoger tu historia clínica y personal, analizar síntomas y revisar pruebas o informes médicos si los aportas. A partir de ahí se elabora una propuesta terapéutica individualizada para las siguientes semanas.",
                        "[U]Consultas de seguimiento",
                        "Revisión de la evolución del caso, ajuste del plan terapéutico y acompañamiento cercano durante el proceso de cambio. La frecuencia se adapta a cada persona.",
                    ],
                }
            },
            "lists": {
                "Pediatría2": [
                    "Bebés con sufrimiento fetal perinatal",
                    "Craneosinostosis, deformidades craneales y problemas del sueño",
                    "Otitis,obstrucción del canal lagrimal",
                    "Espasticidad, rigidez, hipotonía o distonías",
                    "Miopatías",
                    "Frenillos",
                    "Sdes y malformaciones genéticas",
                    "Deformidades de la columna vertebral, escoliosis, cifosis...",
                    "PCI",
                    "Cólicos del lactante, gases, estreñimiento,disquecia, reflujo",
                    "Problemas de atención y en el desarrollo motriz"
                ],
                "Fisioterapia del Suelo Pélvico2": [
                    "Incontinencia urinaria o fecal",
                    "Prolapsos (descenso de órganos pélvicos)",
                    "Dolor pélvico crónico",
                    "Disfunciones sexuales (dolor en las relaciones, disfunción eréctil, etc.)",
                    "Recuperación postparto o postcirugía pélvica",
                    "Preparación para el parto"
                ],
                "Fisioterapia del Suelo Pélvico4": [
                    "Ejercicios de fortalecimiento (como los ejercicios de Kegel)",
                    "Terapia manual y miofascial",
                    "Biofeedback y electroestimulación",
                    "Educación postural y entrenamiento funcional"
                ],
                "Invasivas0": [
                    "Reduce la concentración de sustancias de estímulos dolorosos,disminuyendo el dolor local y referido",
                    "Relaja la musculatura",
                    "Revascularización",
                    "Restauración de patrones normales de movimiento"
                ],
                "¿Qué patologías se pueden abordar?0": [
                    "Salud digestiva",
                    "Colon irritable, gastritis, reflujo, intolerancias, disbiosis (SIBO, parásitos)",
                    "Desajustes hormonales",
                    "SOP, endometriosis, menopausia, hipo/hipertiroidismo, dismenorrea, amenorrea",
                    "Metabolismo",
                    "Diabetes tipo 1 y 2, resistencia a la insulina, colesterol elevado, hipertensión, sobrepeso",
                    "Estado de ánimo",
                    "Estrés, ansiedad, insomnio, fatiga crónica, depresión",
                    "Inflamación y dolor",
                    "Fibromialgia, artritis, artrosis, problemas articulares",
                    "Autoinmunidad",
                    "Crohn, colitis, alergias, psoriasis, Hashimoto, entre otros",
                    "Detoxificación y salud hepática",
                    "Reducción de tóxicos, metales pesados y equilibrio de la microbiota",
                ]
            },
            "pictures": {
                "Pediatría": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/pediatria1LQ.b7a5b13b.jpg",
                        "topPosition": "0"
                    },
                    {
                        "picture": "https://epanareda.github.io/ossis/img/pediatria2LQ.8fd545e6.jpg",
                        "topPosition": "-40%"
                    },
                    {
                        "picture": "https://epanareda.github.io/ossis/img/pediatria3LQ.7ff272ac.jpg",
                        "topPosition": "-30%"
                    },
                    {
                        "picture": "https://epanareda.github.io/ossis/img/pediatria4LQ.2ed8c757.jpg",
                        "topPosition": "-40%"
                    }
                ],
                "Fisioterapia del Suelo Pélvico": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/solPelvicLQ.jpg",
                        "topPosition": "-15%"
                    }
                ],
                "Geriatría": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/geriatria1LQ.0e32ab70.jpg",
                        "topPosition": "0"
                    }
                ],
                "Deportivo": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/deportivo1LQ.095b86a6.jpg",
                        "topPosition": "-15%"
                    }
                ],
                "Vendajes": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/vendajesLQ.53e699c8.jpg",
                        "topPosition": "-25%"
                    }
                ],
                "Auriculoterapia": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/auriculoterapiaLQ.1c54f58d.jpg",
                        "topPosition": "0"
                    }
                ],
                "Reflexologia podal": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/reflex-podal1LQ.3e2ef91c.jpg",
                        "topPosition": "-20%"
                    }
                ],
                "Invasivas": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/invasivas1LQ.05562916.jpg",
                        "topPosition": "0"
                    }
                ],
                "Craneal": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/craneal1LQ.f7e95d74.jpg",
                        "topPosition": "0"
                    }
                ],
                "Visceral": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/visceral1LQ.1ae340be.jpg",
                        "topPosition": "-25%"
                    }
                ],
                "Aparato locomotor": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/aparato-locomotorLQ.3ac78eab.jpg",
                        "topPosition": "-30%"
                    }
                ],
                "Deportistas": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/indiba2LQ.c616254e.jpg",
                        "topPosition": "-25%"
                    },
                    {
                        "picture": "https://epanareda.github.io/ossis/img/indiba3LQ.db6f94e9.jpg",
                        "topPosition": "0"
                    }
                ],
                "¿Qué patologías se pueden abordar?": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/pnie.jpg",
                        "topPosition": "-35%"
                    },
                ]
            }
        },
        "activities": {
            "title": "ACTIVIDADES",
            "mainLinks": {
                "Ejercicio Funcional": {
                    "link": "#functional-exercise-container",
                    "text": "Más información",
                    "image": "https://epanareda.github.io/ossis/img/ejFunctLink.jpg",
                    "imageAlign": "align-top"
                },
                // "Yoga": {
                //     "link": "#yoga-container",
                //     "text": "Más información",
                //     "image": "https://epanareda.github.io/ossis/img/hathaLQ.01af4e46.jpg",
                //     "imageAlign": "align-top-hata"
                // },
                // "Música en Familia": {
                //     "link": "#music-with-family-container",
                //     "text": "Más información",
                //     "image": "https://epanareda.github.io/ossis/img/musicaFamLQ.0085d396.jpg",
                //     "imageAlign": ""
                // }
            },
            "functionalExerciceInfo": {
                "title": "Ejercicio Funcional",
                "description": "",
                "methodsOfTreatement": {
                    "Clases de Ejercicio Funcional en Ossis": [
                        "En Ossis, sabemos lo importante que es moverse de manera efectiva para llevar una vida activa y saludable. Por eso, ofrecemos clases de ejercicio funcional, diseñadas para mejorar tu fuerza, resistencia, movilidad y coordinación, siempre adaptadas a tus necesidades."
                    ],
                    "¿Qué es el ejercicio funcional?": [
                        "El ejercicio funcional se basa en movimientos que simulan las actividades de la vida diaria. Este enfoque no solo mejora tu rendimiento físico, sino que también fortalece tu cuerpo de manera integral, ayudándote a prevenir lesiones y a realizar tus tareas cotidianas con mayor facilidad y seguridad."
                    ],
                    "¿Cómo son nuestras clases?": [
                        "En cada sesión, utilizamos herramientas como gomas, kettlebells y mancuernas, combinadas con ejercicios personalizados según tu nivel físico. Nuestros fisioterapeutas especializados te acompañarán en todo momento, asegurándose de que realices cada movimiento correctamente y de forma segura."
                    ],
                    "Beneficios de nuestras clases": [
                        "Estos son los principales beneficios de realizar ejercicio funcional:"
                    ],
                    "Horarios flexibles": [
                        "Sabemos que tu tiempo es valioso, por eso ofrecemos horarios muy flexibles, tanto en turnos de mañana como de tarde, para que puedas elegir el momento que mejor se adapte a tu rutina.",
                        "¡Ven a probar una clase y descubre cómo el ejercicio funcional puede transformar tu vida!",
                        "Contáctanos para más información o para reservar tu plaza."
                    ]
                }
            },
            // "yogaInfo": {
            //     "title": "Yoga",
            //     "description": "",
            //     "methodsOfTreatement": {
            //         "Yin Yoga": [
            //             "És una fusión entre Hatha Yoga i la Medicina China Es una práctica introspectiva i meditativa que fomenta un estado de calmas y conciencia plena la cual se enfoca en trabajar los tejidos más profunda como los ligamentos, los tendones y fascia mediante posturas mantenidas durante un tiempo prolongado que permite un estiramiento profundo y mayor apertura de las articulaciones.",
            //             "Con la práctica de Yin activamos nuestro SNP induciendo a la calma i a la relajación contrarrestando el estado constante de acción y alerta de nuestra vida diària mediante la práctica de asanas Yin y su movimiento de energía pero también con la respiración, la meditación y el Mindfulness.",
            //             "Con la respiración podemos controlar nuestro SNP que es el puente entre cuerpo y mente."
            //         ],
            //         "Hatha Yoga": [
            //             "Forma tradicional de Yoga que combina la práctica de asanas y respiración así como técnicas de respiración que se centra en el equilibrio físico, mental y espiritual con el objetivo de reducir el estrés y ansiedad, mejorar la fuerza y flexibilidad física y fomenta una conexión profunda entre cuerpo y mente.",
            //             "La clave de la enseñanza y de su metodología es la respiración focalizando su control sobre el cuerpo físico y su prana y un camino hacia el autoconocimiento."
            //         ],
            //         "Hipopresivos": [
            //             "Ejercicios posturales y respiratorios con lo s que se trabaja toda la musculatura respiratoria asociados a un ritmo respiratorio controlado i metodología de entrenamiento que se caracteriza en la disminución de la presión intra abdominal.",
            //             "Sus beneficios entre otros son la tonificación de la musculatura abdomino perineal, mejora postural, prevención de aparición de hernias prevenir y reeducar síntomas de incontinencia urinaria, liberación miofascial, etc."
            //         ]
            //     }
            // },
            // "musicWithFamilyInfo": {
            //     "title": "Música en Familia",
            //     "description": "",
            //     "methodsOfTreatement": {
            //         "Música en Familia": [
            //             "Esta propuesta está dirigida a las familias (adulto/a y niño/a de 0 a 3 años) y se basa en la estimulación de los niños/as a través de la música y el juego. Así, además de pasar un buen rato disfrutando de la música, el juego, cantar y bailar, se trabaja la psicomotricidad, el lenguaje, la coordinación, la adquisición y refuerzo de los hábitos, de rutinas, la comunicación, la expresión...compartiendo así un rato único de conexión entre el adulto/a y el niño/a."
            //         ]
            //     }
            // },
            "lists": {
                "Beneficios de nuestras clases0": [
                    "Aumento de la fuerza y resistencia muscular.",
                    "Mejora de la postura y estabilidad.",
                    "Reducción del riesgo de lesiones.",
                    "Complemento ideal para la recuperación funcional tras lesiones o cirugías.",
                    "Adaptación personalizada a tus objetivos y capacidades."
                ]
            },
            "pictures": {
                "Beneficios de nuestras clases": [
                    {
                        "picture": "https://epanareda.github.io/ossis/img/ejercicioFuncionalLQ.663e6b3b.jpg",
                        "topPosition": "-5px"
                    }
                ],
                // "Yin Yoga": [
                //     {
                //         "picture": "https://epanareda.github.io/ossis/img/yinLQ.c7f5ea24.jpg",
                //         "topPosition": "-40px"
                //     }
                // ],
                // "Hatha Yoga": [
                //     {
                //         "picture": "https://epanareda.github.io/ossis/img/hathaLQ.01af4e46.jpg",
                //         "topPosition": "-40px"
                //     }
                // ],
                // "Hipopresivos": [
                //     {
                //         "picture": "https://epanareda.github.io/ossis/img/hipopresivosLQ.182a0da3.jpg",
                //         "topPosition": "-15px"
                //     }
                // ],
                // "Música en Familia": [
                //     {
                //         "picture": "https://epanareda.github.io/ossis/img/musicaFamLQ.0085d396.jpg",
                //         "topPosition": "0px"
                //     }
                // ]
            }
        },
        "contactUs": {
            "title": "CONTACTO",
            "onlyWhatsapp": "solo whatsapp",
            "address": "C/ Major 2, La Beguda Alta (08782)"
        }
    }
}

export default TEXT;